<template>
  <div>
    <button class="BUTTON " @click.prevent="$emit('click')">
      <span class="TEXT">Filter</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'filter-button',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .IMG {
    width: 16px;
    height: 12px;
    @include tablet {
      width: 20px;
      height: 15px;
    }
  }
  .BUTTON {
    border: 1px solid $color-depot;
    line-height: 22px;
    color: $color-depot;
    background-color: white;
    border-radius: 3px;
    height: 28px;
    .TEXT {
      font-size: 14px;
    }
  }
</style>
